module.exports = __webpack_public_path__ + "img/267.6d4b6f3a.jpg";